<ng-container *ngIf="showSmartAppBanner">
    <div class="banner-area" #bannerArea [style.height.px]="bannerCurrentHeight">
        <app-smart-app-banner></app-smart-app-banner>
    </div>
</ng-container>

<div id="header-reg-main" class="header-min" [ngClass]="{ 'show-header': isAtTop }">
    <div id="header-wp" class="header-top-bar">
        <div id="mb-brand-reg">
            <div id="brand-center">
                <a id="mbbrand" class="header-link" href="/">
                    <picture class="brandhub-header__logo">
                        <img
                            src="assets/images/MB-star_white.svg"
                            alt="Mercedes-Benz brand logo"
                            class="brandhub-picture brandhub-picture--contain"
                            style="width: 48px; height: auto"
                            alt="logo"
                        />
                    </picture>
                </a>
            </div>
        </div>
        <div
            [ngClass]="showMenu ? 'menu-navigation-animation' : 'menu-navigation-animation-goup'"
            class="l1-menu"
        >
            <ng-container>
                <span
                    class="menu-item top-menu-font"
                    *ngIf="isLanguageSelector; else langSelectionBlock"
                >
                    <span
                        class="glow-button lang-padding"
                        [ngClass]="this.selectedLang === 'de-DE' ? 'language-active' : ''"
                        (click)="openLanguagePicker()"
                        >{{ languageToDisplay }}</span
                    >
                </span>
            </ng-container>
            <ng-template #langSelectionBlock> </ng-template>
            <ng-container>
                <span class="menu-item top-menu-font privacy">
                    <span (click)="navigateToProviderPage()">{{
                        'CP_LM_FOOTER_PROVIDER' | translate
                    }}</span>
                    /
                    <span (click)="navigateToPrivacyPage()">{{
                        'CP_LM_FOOTER_PRIVACY' | translate
                    }}</span>
                </span>
            </ng-container>
            <ng-container>
                <div
                    class="login-button-class"
                    [ngClass]="
                        showMenu ? 'menu-navigation-animation' : 'menu-navigation-animation-goup'
                    "
                >
                    <span
                        *ngIf="showLoginLink"
                        class="menu-item top-menu-font glow-button"
                        (click)="triggerLogin()"
                        >{{ 'CP_LM_LANDINGPAGE_LOGIN' | translate }}</span
                    >
                    <span
                        *ngIf="!enableMyProfile || showLogout"
                        class="menu-item top-menu-font glow-button"
                        (click)="logout()"
                        >{{ 'CP_LM_LANDINGPAGE_LOGOUT' | translate }}</span
                    >
                </div>
            </ng-container>
            <div *ngIf="showMenu || currentUser" class="login-class">
                <ng-container *ngIf="enableMyProfile">
                    <div id="user-profile" class="desk-only">
                        <span (click)="profileClicked()" class="profile-base">
                            <img
                                class="prof-image"
                                *ngIf="!isMyProfileVisible"
                                src="../../../assets/images/profile-fallback.png"
                                alt=""
                            />
                            <img
                                class="prof-image"
                                *ngIf="isMyProfileVisible && !!profileInfo"
                                style="background-image: url({{
                                    profileInfo.profileImageUrl
                                        ? profileInfo.profileImageUrl
                                        : profileImage
                                }});"
                                alt=""
                            />
                        </span>
                        <span class="profile-name" (click)="profileClicked()">
                            <span class="first-name" *ngIf="!isMyProfileVisible"
                                >{{ 'CP_LM_MAINPAGE_MYPROFILE' | translate }}
                            </span>
                            <span class="first-name" *ngIf="isMyProfileVisible && !!profileInfo">{{
                                profileInfo.nickName || profileInfo.firstName
                            }}</span>
                        </span>
                        <div class="profile-menu" *ngIf="!showLogout">
                            <ul>
                                <li (click)="logout()">
                                    <span class="glow-button">{{
                                        'CP_LM_LANDINGPAGE_LOGOUT' | translate
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container>
            <div class="menu-btn-top" [ngClass]="!showBottomMenu ? '' : 'menu-close'">
                <span (click)="showDropDownInMobile()" class="menu-item-menu-btn">{{
                    'CP_LM_LANDINGPAGE_MENU' | translate
                }}</span>
                <span (click)="showDropDownInMobile()" class="menu-item-menu-btn">{{
                    'CP_LM_LANDINGPAGE_CLOSE' | translate
                }}</span>
            </div>
        </ng-container>
    </div>
    <div class="header-top-bar-backdrop"></div>
    <ng-container>
        <div class="header-l2-menu">
            <div
                [ngClass]="
                    showMenu ? 'header-navigation-animation' : 'header-navigation-animation-goup'
                "
                (mouseleave)="hideDropMenu()"
                id="header-profile"
                *ngIf="showHeader && toggleHeader"
                class="header-navigation"
            >
                <span
                    *ngIf="!isProd"
                    id="home"
                    [ngClass]="this.selectedCategory === '/explore' ? 'active-menu' : ''"
                    (click)="openExploreModule()"
                    ><span class="menu-item">{{
                        'CP_LM_LANDINGPAGE_EXPLORE' | translate
                    }}</span></span
                >
                <span
                    *ngIf="isMyStoriesVisible"
                    id="mestories"
                    [ngClass]="this.selectedCategory === '/stories' ? 'active-menu' : ''"
                    (click)="handleMyStoriesNavigationClick()"
                    ><span class="menu-item">{{
                        'CP_LM_MAINPAGE_MYSTORIES' | translate
                    }}</span></span
                >
            </div>
        </div>
        <div class="header-l2-menu-backdrop"></div>
    </ng-container>

    <ng-container>
        <div
            [ngClass]="showBottomMenu ? 'mobile-list-comedown' : 'mobile-list-goup'"
            class="mobile-list"
        >
            <div class="mobile-nav-wrapper">
                <div class="mobile-main-nav">
                    <span
                        *ngIf="!isProd"
                        id="mobilehome"
                        [ngClass]="this.selectedCategory === '/explore' ? 'active-menu' : ''"
                        class="menu-item glow-button"
                        (click)="openExploreModule()"
                        >{{ 'CP_LM_LANDINGPAGE_EXPLORE' | translate }}</span
                    >
                    <span
                        *ngIf="isMyStoriesVisible"
                        id="mobilemestories"
                        [ngClass]="
                            this.selectedCategory === '/home' ||
                            this.secondLastUrlElement === '/experience'
                                ? 'active-menu'
                                : ''
                        "
                        class="menu-item glow-button menu-options"
                        (click)="handleMyStoriesNavigationClick()"
                        >{{ 'CP_LM_MAINPAGE_MYSTORIES' | translate }}</span
                    >
                </div>
                <div class="mobile-bottom-nav">
                    <div class="mobile-login-block">
                        <ng-container>
                            <span
                                *ngIf="showLoginLink"
                                class="menu-item-mobile-menu"
                                (click)="triggerLogin()"
                                >{{ 'CP_LM_LANDINGPAGE_LOGIN' | translate }}</span
                            >
                            <span
                                *ngIf="!enableMyProfile"
                                class="menu-item-mobile-menu"
                                (click)="logout()"
                                >{{ 'CP_LM_LANDINGPAGE_LOGOUT' | translate }}</span
                            >
                        </ng-container>

                        <!-------Smaller Devices Code------->
                        <ng-container *ngIf="enableMyProfile">
                            <div id="user-profile-mobile" *ngIf="!showLoginLink">
                                <div id="user-profile-info-mobile">
                                    <span (click)="profileClicked()" class="profile-base">
                                        <img
                                            class="prof-image"
                                            *ngIf="!isMyProfileVisible"
                                            src="../../../assets/images/profile-fallback.png"
                                            alt=""
                                        />
                                        <img
                                            class="prof-image"
                                            *ngIf="isMyProfileVisible && !!profileInfo"
                                            style="background-image: url({{ profileImage }});"
                                            alt=""
                                        />
                                    </span>
                                    <span class="profile-name" (click)="profileClicked()">
                                        <span class="first-name" *ngIf="!isMyProfileVisible"
                                            >{{ 'CP_LM_MAINPAGE_MYPROFILE' | translate }}
                                        </span>
                                        <span
                                            class="first-name"
                                            *ngIf="isMyProfileVisible && !!profileInfo"
                                            >{{
                                                profileInfo.nickName || profileInfo.firstName
                                            }}</span
                                        >
                                    </span>
                                </div>
                                <div class="profile-menu" *ngIf="!showLoginLink">
                                    <ul>
                                        <li (click)="logout()">
                                            <span class="glow-button">{{
                                                'CP_LM_LANDINGPAGE_LOGOUT' | translate
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <span class="menu-item">
                        <span
                            class="glow-button lang-padding"
                            [ngClass]="this.selectedLang === 'de-DE' ? 'language-active' : ''"
                            (click)="openLanguagePicker()"
                            >{{ languageToDisplay }}</span
                        >
                    </span>
                    <span class="menu-item glow-button">
                        <span (click)="navigateToProviderPage()">{{
                            'CP_LM_FOOTER_PROVIDER' | translate
                        }}</span>
                        /
                        <span (click)="navigateToPrivacyPage()">{{
                            'CP_LM_FOOTER_PRIVACY' | translate
                        }}</span>
                    </span>
                </div>
            </div>
        </div>
    </ng-container>
</div>
<div id="bg-blur"></div>
<div id="bg-mobile-blur"></div>

<div *ngIf="isProfileClicked">
    <app-edit-profile (cancelClicked)="cancelClicked($event)"></app-edit-profile>
</div>
